import React from "react";
import SuggestedTips from "src/components/SuggestedTips/SuggestedTips";
import TipAuthorizationSettings from "src/components/TipAuthorizationSettings/TipAuthorizationSettings";
import DineInAutoTipSettings from "src/components/DineInAutoTipSettings/DineInAutoTipSettings";

/**
 * Combined Tip settings: Tip Authorization, Dine-in auto-tip, and Suggested Tips.
 * Tip tab is shown only when store has Advanced tip settings (Pro). All use GET_STORE_TIP_SETTINGS / UPDATE_STORE_TIP_SETTINGS.
 */
const TipSettings = () => {
  return (
    <div className="w-full max-w-[760px] space-y-3">
      <TipAuthorizationSettings />
      <DineInAutoTipSettings />
      <SuggestedTips />
    </div>
  );
};

export default TipSettings;
